import { defineStyleConfig } from "@chakra-ui/react";

// Espelha o tema do Input (padrão Rede Frota - Cardan): borda soft-200, fundo branco,
// foco com borda strong. Sem isso o Select usa o cinza genérico do Chakra e destoa dos
// demais controles da barra de filtros.
const Select = defineStyleConfig({
  variants: {
    outline: {
      field: {
        borderColor: "neutrals.stroke.soft-200",
        backgroundColor: "neutrals.background.white-0",
        _focus: {
          borderColor: "neutrals.text.strong-950",
          boxShadow: "none",
        },
        _disabled: {
          color: "neutrals.text.strong-950",
          backgroundColor: "neutrals.background.weak-50",
          borderColor: "neutrals.stroke.soft-200",
        },
      },
    },
  },
  defaultProps: {
    variant: "outline",
  },
});

export default Select;
